import React from 'react'
import Logo from "../../img/blue.svg";

function HeaderInternal() {
    return (
        <>
            <header className="py-3 bg-[#E7E9EC]">
                <div className="container px-3 mx-auto flex justify-between items-center">
                    {/*<a href="/">*/}
                    {/*    <img src={Logo} alt="Business Wisdom Summit" className="w-[100px]"/>*/}
                    {/*</a>*/}
                    <a href="/" className="w-[100px]">
                        <img src={Logo} alt="MRKTNG"
                             className="w-[100px]" style={{transition: '0.5s'}}/>
                    </a>
                    <nav>
                        <ul className="flex gap-4">
                            <li><a href="/">Головна</a></li>
                        </ul>
                    </nav>
                </div>

            </header>
        </>
    )
}

export default HeaderInternal;